// ============================================================================
// page-author / articles.js
// ----------------------------------------------------------------------------
// "Related Articles" — left-aligned Flickity strip of post cards authored by
// the current user, with external prev/next arrows in
// `.author-article__nav-button.{prev,next}`.
// ============================================================================

import { initCarousels } from "../carousel";

document.addEventListener("DOMContentLoaded", function () {
  const sliderEl = document.querySelector(".author-article__cards");
  if (!sliderEl) return;

  sliderEl.style.display = "block";

  const instances = initCarousels(".author-article__cards", {
    cellAlign: "left",
    contain: true,
    pageDots: false,
    wrapAround: false,
    imagesLoaded: true,
  });
  if (!instances || !instances.length) return;
  const flkty = instances[0].flickity;

  const prev = document.querySelector(".author-article__nav-button.prev");
  const next = document.querySelector(".author-article__nav-button.next");
  if (prev)
    prev.addEventListener("click", function () {
      flkty.previous();
    });
  if (next)
    next.addEventListener("click", function () {
      flkty.next();
    });
});
